import styled, { css } from 'styled-components';

export const CardBadgeWrapper = styled.span(
    ({ theme: { palette, radius } }) => css`
        background-color: ${palette.neutral.white};
        border-radius: ${radius[8]}px;
        padding: 2px 8px;

        p {
            color: ${palette.secondary.default};
        }
    `,
);
